import modelMap from 'hec/builder/model-map'
import React from 'react'
import * as Icons from 'hec/assets/icons'
import {isPreviewing, isEditing} from '@builder.io/sdk-react'
import {useFetchBuilderReference} from '@/builder/hooks/useFetchBuilderReference'
import {IconPickerProps} from './types'

const IconPicker: React.FC<IconPickerProps> = ({...props}) => {
    const {iconName, useReference, CustomIcon, attributes, useBuilderImageAttributes} = props
    const {data: fetchedData} = useFetchBuilderReference({
        model: modelMap.customIcons,
        shouldQuery: true,
        shouldEnrich: true,
        referenceId: CustomIcon?.id
    })

    const IconComponent = Icons[iconName as keyof typeof Icons]
    if (!IconComponent) return null
    if (useReference && CustomIcon) {
        return (
            <picture>
                <img
                    loading="lazy"
                    fetchPriority="auto"
                    role="presentation"
                    {...attributes}
                    className={!useBuilderImageAttributes ? 'h-6 w-6' : attributes?.className}
                    src={fetchedData?.data?.iconImage || ''}
                    alt="Custom Icon"
                    data-testid="icon-picker-CustomIconComponent"
                    sizes="(max-width: 998px) 2vw, 2vw"
                />
            </picture>
        )
    }
    return <IconComponent {...attributes} {...props} data-testid="icon-picker-IconComponent" />
}

export default IconPicker
